import { render, staticRenderFns } from "./ProgressBarCategory.vue?vue&type=template&id=354f8dc2&scoped=true&"
import script from "./ProgressBarCategory.vue?vue&type=script&lang=js&"
export * from "./ProgressBarCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBarCategory.vue?vue&type=style&index=0&id=354f8dc2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f8dc2",
  null
  
)

export default component.exports